import React, { useState } from 'react'
import { ButtonGroupComponent } from 'shared/components/button_group'

interface groupTabSwitcherProps {
  tabTitles: string[]
  tabValues: string[]
  defaultTab: string
  onPress(setTab: string): void
}

export default function GroupTabSwitcher({
  onPress,
  defaultTab,
  tabTitles,
  tabValues,
}: groupTabSwitcherProps) {
  const [selectedIndex, setSelectedIndex] = useState(
    tabValues.indexOf(defaultTab)
  )

  return (
    <ButtonGroupComponent
      buttons={[...tabTitles]}
      selectedIndex={selectedIndex}
      onPress={value => {
        setSelectedIndex(value)
        onPress(tabValues[value])
      }}
    />
  )
}
